var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M452.432 370.6a8 8 0 0 1-11.323 11.309L420.8 361.6v64.281a8 8 0 0 1-16 0V361.6l-20.31 20.306a8 8 0 0 1-11.308-11.306l33.959-33.968a8.013 8.013 0 0 1 11.323 0zm42.951 23.509a83.18 83.18 0 0 0-72.56-92.6 85.261 85.261 0 0 0-10.19-.623 83.187 83.187 0 1 0 82.75 93.219zm-432.451 32.9h260.431a99.16 99.16 0 0 1 111.481-139.582v-63.048l-52.683-52.693-109.288 78.782 32.581 22.839a8 8 0 1 1-9.181 13.1l-164.2-115.1L16 269.467v110.6a46.987 46.987 0 0 0 46.928 46.937zm0-382.23h324.98a46.981 46.981 0 0 1 46.932 46.931v110.038l-46.182-46.178a8.008 8.008 0 0 0-10.342-.84L259 240.75l-122.79-86.081a8.009 8.009 0 0 0-9.761.448L16 248.52V91.71a46.98 46.98 0 0 1 46.932-46.932zm427.941 278.14a98.523 98.523 0 0 0-40.031-30.4V91.71a63 63 0 0 0-62.93-62.931H62.932A63 63 0 0 0 0 91.71v288.361a63.011 63.011 0 0 0 62.931 62.94h270.1c.552.75 1.123 1.5 1.7 2.236a99.177 99.177 0 1 0 156.142-122.328zM252.242 101.627a36.672 36.672 0 1 1-36.671 36.673 36.722 36.722 0 0 1 36.671-36.671zm0 89.341a52.67 52.67 0 1 1 52.669-52.67 52.731 52.731 0 0 1-52.669 52.67z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c9b3ccf795d9a160559be5707742f30e.svg";
export { ForwardRef as ReactComponent };